<template>
  <BaseCard class="flex flex-col">
    <BaseCardBody>
      {{ funnel.name }}
    </BaseCardBody>
    <BaseCardBody class="flex-1 flex" clear-padding>
      <FunnelChart :stages="funnel.stages" compact class="flex-1" />
    </BaseCardBody>
    <BaseCardBody>
      <div class="flex space-x-2 justify-end">
        <FunnelViewAction :funnel="funnel" />
        <FunnelEditAction :funnel="funnel" />
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import FunnelChart from '@/components/Funnel/FunnelChart.vue';
import FunnelViewAction from './FunnelViewAction.vue';
import FunnelEditAction from './FunnelEditAction.vue';

export default {
  components: { FunnelChart, FunnelViewAction, FunnelEditAction },
  props: {
    funnel: {
      type: Object,
      required: true,
    },
  },
};
</script>
